import { TREATMENT_MONITOR_GRAPHQL_ENDPOINT } from 'config';

export const CHATTER_DATE_FORMAT = 'DD MMM YYYY, hh:mm A';

export const IMAGE_EXTENSIONS = new Set([
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'bmp',
  'svg'
]);

export const TREATMENT_MONITOR_BASE = (
  TREATMENT_MONITOR_GRAPHQL_ENDPOINT || ''
).replace(/\/graphql$/, '');

export const MENTION_REGEX = /@([^<]+)<CCID:([^>]+)>/g;

export const HTML_TAG_TO_MARKUP: Record<string, string> = {
  b: 'Bold',
  strong: 'Bold',
  i: 'Italic',
  em: 'Italic',
  u: 'Underline',
  s: 'Strikethrough',
  strike: 'Strikethrough',
  del: 'Strikethrough',
  ul: 'UnorderedList',
  ol: 'OrderedList',
  li: 'ListItem',
  p: 'Paragraph',
  div: 'Paragraph'
};

export const MARKUP_TO_HTML_TAG: Record<string, string> = {
  Bold: 'b',
  Italic: 'i',
  Underline: 'u',
  Strikethrough: 's',
  Paragraph: 'p',
  UnorderedList: 'ul',
  OrderedList: 'ol',
  ListItem: 'li'
};

const TOOLBAR_BTN_BASE =
  'h-7 w-7 flex items-center justify-center rounded text-DEFAULT_TEXT';
export const TOOLBAR_BTN_INACTIVE = `${TOOLBAR_BTN_BASE} hover:bg-GRAY5`;
export const TOOLBAR_BTN_ACTIVE = `${TOOLBAR_BTN_BASE} bg-PRIMARY/10 text-PRIMARY ring-1 ring-PRIMARY/30`;

export const PASTE_SKIP_TAGS = new Set([
  'script',
  'style',
  'meta',
  'link',
  'noscript',
  'svg',
  'math',
  'head',
  'title',
  'img',
  'video',
  'audio',
  'canvas',
  'iframe',
  'object',
  'embed',
  'form',
  'input',
  'textarea',
  'select',
  'button'
]);

export const PASTE_HEADING_TAGS = new Set(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']);

export const PASTE_BLOCK_TAGS = new Set([
  'div',
  'blockquote',
  'pre',
  'section',
  'article',
  'header',
  'footer',
  'nav',
  'main',
  'aside',
  'figure',
  'figcaption',
  'address',
  'details',
  'summary'
]);

export const PASTE_INLINE_FORMAT_TAGS = new Set([
  'b',
  'strong',
  'i',
  'em',
  'u',
  's',
  'strike',
  'del'
]);

export const PASTE_TAG_NORMALIZE: Record<string, string> = {
  strong: 'b',
  em: 'i',
  strike: 's',
  del: 's'
};

export const CRM_SENT_LINE_PREFIX = 'Message sent from CRM';

export const CRM_CCID_REGEX = /<ccId:([^>]+)>/gi;
